import React from "react";
import SuccessIcon from "../../assets/img/check_icone_alert.png";

export function Success(props) {
  return (
    <div
      className="modal fade border-0"
      id={props.id}
      tabIndex="-1"
      aria-labelledby={props.id}
      aria-hidden="true"
      style={{ borderRadius: "10px" }}
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              id="btnClose"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body pt-0 pb-4">
            <div className="row">
              <div className="w-100 d-flex justify-content-center">
                <img src={SuccessIcon} width={80} height={80} alt="" />
              </div>
              <div className="w-100 d-flex justify-content-center mt-3 px-4">
                <span className="ff-univanova-600 text-cl-cyan text-center fz-24">{props.title}</span>
              </div>
              <div className="w-100 d-flex justify-content-center mt-2 mb-3 px-4">
                <span style={{ textAlign: "center" }} className="ff-univanova text-cl-black fz-14">
                  {props.description}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SuccessWithButton(props) {
  return (
    <div
      className="modal fade border-0"
      id={props.id}
      tabIndex="-1"
      aria-labelledby={props.id}
      aria-hidden="true"
      style={{ borderRadius: "10px" }}
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              id="btnClose"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body pt-0">
            <div className="row">
              <div className="w-100 d-flex justify-content-center">
                <img src={SuccessIcon} width={80} height={80} alt="" />
              </div>
              <div className="w-100 d-flex justify-content-center mt-3 px-4">
                <span className="ff-univanova-600 text-cl-cyan fz-24">{props.title}</span>
              </div>
              <div className="w-100 d-flex justify-content-center mt-2 mb-3 px-4">
                <span style={{ textAlign: "center" }} className="ff-univanova text-cl-black fz-14">
                  {props.description}
                </span>
              </div>
              <div className="w-100 d-flex justify-content-center mt-2 mb-3 px-4">
                <button
                  onClick={props.buttonOnClick}
                  className="btn bg-gradient-cyan-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center ff-univanova-medium"
                >
                  {props.buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ConfirmDelete(props) {
  return (
    <div
      id={props.id}
      className={`modal fade border-0 ${props.className}`}
      tabIndex="-1"
      aria-labelledby={props.id}
      aria-hidden="true"
      style={{ borderRadius: "10px" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              id="btnClose"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{ backgroundSize: "15px" }}
            ></button>
          </div>
          <div className="modal-body pt-0 mx-4">
            <div className="d-flex justify-content-center row">
              <div className="w-100 d-flex justify-content-center mb-2 ">
                <span className="ff-univanova-medium text-cl-black-2 fz-20" style={{ textAlign: "center" }}>
                  {props.title}
                </span>
              </div>
              <div className="w-100 d-flex justify-content-center mb-4">
                <span className="ff-univanova-medium text-cl-black-4 fz-16" style={{ textAlign: "center" }}>
                  {props.subTitle}
                </span>
              </div>
              <div className="row mb-3 justify-content-center ">
                <button
                  className={`${
                    props.classNameCancelButton !== undefined ? props.classNameCancelButton : ""
                  } col-auto btn btn-white button-white-primary fz-14 px-3 ff-univanova-regular`}
                  data-bs-dismiss="modal"
                  type="button"
                  style={{ marginRight: "24px" }}
                >
                  Voltar
                </button>
                <button
                  onClick={props.onClick}
                  data-bs-dismiss="modal"
                  className="col-6 btn fz-14 btn-cl-red text-white ff-univanova-medium "
                >
                  {props.text}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
